import React from 'react';
import DesktopAppAdvertisement from './components/DesktopAppAdvertisement';
import MobileAppAdvertisement from './components/MobileAppAdvertisement';

function AppAdvertisement() {
  return (
    <div className="hidden lg:block z-0">
      <DesktopAppAdvertisement />
      <MobileAppAdvertisement />
    </div>
  );
}

export default AppAdvertisement;
